import { Grid, Typography } from "@mui/material";
import { ApprovalButton } from "src/grading/approvalButton";
import { ApprovalGradeResult, GradeResult } from "src/grading/models";
import { useAppSelector } from "src/store/hooks";
import {
  selectGradingStep,
  selectGradingTest,
} from "src/store/reducers/grading/gradingSlice";
import { TestStepDefinitionFormat } from "src/store/reducers/tests/testsApiSlice";

interface BodyCompositionStepperProps {
  onGrade: (stepGrade: GradeResult) => void;

  currentGrade: GradeResult;
  stepMetadata: TestStepDefinitionFormat | undefined;
  prevEnd: number | null; // The end time of the previous step, for rest time displays
}

const BodyCompositionStepper = ({
  onGrade,
  currentGrade,
  stepMetadata,
  prevEnd,
}: BodyCompositionStepperProps) => {
  const test = useAppSelector(selectGradingTest);
  const step = useAppSelector(selectGradingStep);

  if (!test || !stepMetadata) {
    return null;
  }

  return (
    <Grid container height={"80vh"} overflow={"scroll"}>
      <Grid item p={4} width={"100%"}>
        {currentGrade.userResult.exerciseCategory === "WHtR" ? (
          <>
            <Grid container justifyContent={"space-between"}>
              <Typography variant="body1" color={"#666"} mt={2}>
                Waist:
              </Typography>

              <Typography variant="caption" mt={2}>
                {currentGrade.userResult.waistCircumference} in.
              </Typography>
            </Grid>

            <Grid container justifyContent={"space-between"}>
              <Typography variant="body1" color={"#666"} mt={2}>
                Height:
              </Typography>

              <Typography variant="caption" mt={2}>
                {currentGrade.userResult.height} in.
              </Typography>
            </Grid>

            <Grid container justifyContent={"space-between"}>
              <Typography variant="body1" color={"#666"} mt={2}>
                WHtR:
              </Typography>

              <Typography variant="caption" mt={2}>
                {currentGrade.userResult.whtr}
              </Typography>
            </Grid>
          </>
        ) : (
          <>
            {currentGrade.userResult.height && (
              <Grid container justifyContent={"space-between"}>
                <Typography variant="body1" color={"#666"} mt={2}>
                  Height:
                </Typography>

                <Typography variant="caption" mt={2}>
                  {currentGrade.userResult.height} in.
                </Typography>
              </Grid>
            )}

            {currentGrade.userResult.weight && (
              <Grid container justifyContent={"space-between"}>
                <Typography variant="body1" color={"#666"} mt={2}>
                  Weight:
                </Typography>

                <Typography variant="caption" mt={2}>
                  {currentGrade.userResult.weight} lb.
                </Typography>
              </Grid>
            )}

            {currentGrade.userResult.abdomenCircumference && (
              <Grid container justifyContent={"space-between"}>
                <Typography variant="body1" color={"#666"} mt={2}>
                  Abdomen Circumference:
                </Typography>

                <Typography variant="caption" mt={2}>
                  {currentGrade.userResult.abdomenCircumference} in.
                </Typography>
              </Grid>
            )}

            {currentGrade.userResult.waistCircumference && (
              <Grid container justifyContent={"space-between"}>
                <Typography variant="body1" color={"#666"} mt={2}>
                  Waist Circumference:
                </Typography>

                <Typography variant="caption" mt={2}>
                  {currentGrade.userResult.waistCircumference} in.
                </Typography>
              </Grid>
            )}

            {currentGrade.userResult.neckCircumference && (
              <Grid container justifyContent={"space-between"}>
                <Typography variant="body1" color={"#666"} mt={2}>
                  Neck Circumference:
                </Typography>

                <Typography variant="caption" mt={2}>
                  {currentGrade.userResult.neckCircumference} in.
                </Typography>
              </Grid>
            )}

            {currentGrade.userResult.bmi && (
              <Grid container justifyContent={"space-between"}>
                <Typography variant="body1" color={"#666"} mt={2}>
                  Calculated BMI:
                </Typography>

                <Typography variant="caption" mt={2}>
                  {currentGrade.userResult.bmi}
                </Typography>
              </Grid>
            )}

            {currentGrade.userResult.bodyFat && (
              <Grid container justifyContent={"space-between"}>
                <Typography variant="body1" color={"#666"} mt={2}>
                  Estimated Body Fat:
                </Typography>

                <Typography variant="caption" mt={2}>
                  {currentGrade.userResult.bodyFat} %
                </Typography>
              </Grid>
            )}
          </>
        )}

        <ApprovalButton
          onClick={(state) => {
            const gradeResult = {
              ...currentGrade,
              approved: state,
              userResult: {
                ...currentGrade.userResult,
                fileKey: test?.exercises[step]?.fileKey as string,
                passFail: state,
              },
            } as ApprovalGradeResult;

            onGrade(gradeResult);
          }}
          approvedLabel={"Passed"}
          denyLabel={"Failed"}
          default={(currentGrade as ApprovalGradeResult)?.userResult?.passFail}
        />
      </Grid>
    </Grid>
  );
};

export default BodyCompositionStepper;
